import {FETCH_POST } from './types';

export const fetchPosts = (posts) => {
  return {
    type: FETCH_POST,
    posts
  }
};

export const fetchAllPosts = () => {
  return (dispatch) => {
    const blocks =  [
      {
        "_id": {
            "$oid": "5c2608ede7179a748798d84a"
        },
        "id": 0,
        "title": "Beställ en bil av oss.",
        "body": "Vi kan hjälpa dig att hitta bilen enligt dina önskemål.",
        "icon": "fa fa-car",
        "icon_color": "info"
      }, 
      {
        "_id": {
            "$oid": "5c260926e7179a748798d84f"
        },
        "id": 1,
        "title": "Köp en bil från vårt lager.",
        "body": "Kontakta oss för att se vad vi har i lager för ett snabbt affär.",
        "icon": "fa fa-credit-card",
        "icon_color": "success"
      },
      {
        "_id": {
            "$oid": "5c260953e7179a748798d85d"
        },
        "id": 2,
        "title": "Vill du sälja din bil?",
        "body": "Kontakta oss och vi kommer att ge dig en kostnadsfri uppskattning av pris.",
        "icon": "fa fa-users",
        "icon_color": "danger"
      }
    ];

    const menu =  [
      {
        "_id": {
            "$oid": "5c2606b5e7179a748798d7a6"
        },
        "id": 0,
        "title": "Start",
        "link": "/"
      },
      {
        "_id": {
            "$oid": "5c2606e3e7179a748798d7ad"
        },
        "id": 1,
        "title": "Om oss",
        "link": "/om-oss"
      },
      {
        "_id": {
            "$oid": "5c2606f3e7179a748798d7b3"
        },
        "id": 2,
        "title": "Kontakt",
        "link": "/kontakt"
      }
    ];

    const page_about_us =  [
      {
        "_id": {
            "$oid": "5c260c0fe7179a748798d93e"
        },
        "id": 0,
        "title": "Om oss",
        "subtitle": "Auto Naxis AB är ett snabbt växande företag i Stockholm",
        "body": "Vi är ett litet familjeföretag grundat 2018 i Stockholm. Vår huvudsakliga verksamhet är inköp och försäljning av begagnade bilar från privatperson och företag i Sverige och EU-länderna. Vi erbjuder våra kunder en gratis bilbedömning. I samarbete med våra partners erbjuder vi möjligheten att transportera bilar i Sverige och EU-länderna samt tillhandahålla auto-mekaniska tjänster i Stockholms område."
      }
    ];

    const page_contact =  [
      {
        "_id": {
            "$oid": "5c260c31e7179a748798d94b"
        },
        "id": 0,
        "title": "Kontakta oss",
        "subtitle": "Tveka inte att kontakta oss idag!",
        "body": ""
      }
    ];

    const slider =  [
      {
        "_id": {
            "$oid": "5c260c4de7179a748798d94e"
        },
        "id": 0,
        "title": "Inköp, försäljning och transport av bilar.",
        "description": "AUTO NAXIS AB STOCKHOLM",
        "img_link": 1
      }
    ];

    const buttons =  [
      {
        "_id": {
            "$oid": "5c26097be7179a748798d868"
        },
        "id": 0,
        "text": "Kontakta oss idag",
        "link": "/kontakt",
        "color": ""
      }, 
      {
        "_id": {
            "$oid": "5c26098be7179a748798d86d"
        },
        "id": 1,
        "text": "Läs mer om oss",
        "link": "/om-oss",
        "color": ""
      }
    ];

    const media =  [
      {
        "_id": {
            "$oid": "5c260b52e7179a748798d8d6"
        },
        "id": 0,
        "title": "page_about",
        "url": "https://drive.google.com/thumbnail?id=1qCHOExxDyhr6jNxyGry5VO5WvtbkYOLN&sz=w1920"
      },
      {
        "_id": {
            "$oid": "5c260b63e7179a748798d8de"
        },
        "id": 1,
        "title": "page_about_full",
        "url": "https://drive.google.com/thumbnail?id=1NRo4wIGnQ7tlAtELA5-EGD73uS2If1Uq&sz=w1920"
      },
      {
        "_id": {
            "$oid": "5c260b74e7179a748798d8ee"
        },
        "id": 2,
        "title": "page_contact",
        "url": "https://drive.google.com/thumbnail?id=1Y3HOxh1EDsTV5DKNpYDFVp9vEpHOTqnS&sz=w1920"
      },
      {
        "_id": {
            "$oid": "5c260b8be7179a748798d8f6"
        },
        "id": 3,
        "title": "page_contact_full",
        "url": "https://drive.google.com/thumbnail?id=1g6RBdVSix-ESTFy0DHwp6mNGnJTySyxF&sz=w1920"
      },
      {
        "_id": {
            "$oid": "5c260b9be7179a748798d8fb"
        },
        "id": 4,
        "title": "homepageHeader",
        "url": "https://drive.google.com/thumbnail?id=1GyQoSA5pLE5NSnucxKhuV7Rx2WniQvdW&sz=w1920"
      },
      {
        "_id": {
            "$oid": "5c260bb0e7179a748798d8fc"
        },
        "id": 5,
        "title": "logo",
        "url": "https://drive.google.com/thumbnail?id=1KUDIZVw4j-iEZkzqeZPwOp7SbeOt9icw&sz=w65"
      },
      {
        "_id": {
            "$oid": "5c260bc6e7179a748798d908"
        },
        "id": 6,
        "title": "logo2",
        "url": "https://drive.google.com/thumbnail?id=1PKKOB5I9mNInSuuA8iansPI6VpNWpCp4"
      }
    ];

    const custom_fields =  [
      {
        "_id": {
            "$oid": "5c260a03e7179a748798d892"
        },
        "id": 0,
        "custom_fields": "title_contact",
        "value": "Kontakta oss",
        "link": ""
      }, 
      {
        "_id": {
            "$oid": "5c260a36e7179a748798d897"
        },
        "id": 1,
        "custom_fields": "body_contact",
        "value": "För ytterligare information du är välkommen att ringa oss på 072 399 18 00 eller kontakta oss via mail info@autonaxis.se",
        "link": ""
      },
      {
        "_id": {
            "$oid": "5c260a4fe7179a748798d89f"
        },
        "id": 2,
        "custom_fields": "color",
        "value": "#c33",
        "link": ""
      },
      {
        "_id": {
            "$oid": "5c260a67e7179a748798d8a7"
        },
        "id": 3,
        "custom_fields": "footer_title",
        "value": "Vi erbjuder olika typer av hjälp...",
        "link": "/kontakt"
      },
      {
        "_id": {
            "$oid": "5c260a8fe7179a748798d8ae"
        },
        "id": 5,
        "custom_fields": "link_2",
        "value": "Gratis bilbedömning. Kontakta oss för mer info",
        "link": "/kontakt"
      },
      {
        "_id": {
            "$oid": "5c260a9ee7179a748798d8b0"
        },
        "id": 6,
        "custom_fields": "link_3",
        "value": "Möjlighet för transport av bilar i Sverige och EU-länder. Kontakta oss för mer info.",
        "link": "/kontakt"
      },
      {
        "_id": {
            "$oid": "5c260aaee7179a748798d8b1"
        },
        "id": 7,
        "custom_fields": "link_4",
        "value": "Ring oss även om du vill sälja din eller köpa en bil. Ta reda på vad vi har på lager idag. Kontakta oss!",
        "link": "/kontakt"
      },
      {
        "_id": {
            "$oid": "5c260ac1e7179a748798d8b3"
        },
        "id": 8,
        "custom_fields": "contact_info_title",
        "value": "Kontaktinformation",
        "link": ""
      },
      {
        "_id": {
            "$oid": "5c260ad5e7179a748798d8b8"
        },
        "id": 9,
        "custom_fields": "contact_info_address",
        "value": "LERBÄCKSGRÄND 14, 124 66 Bandhagen, STOCKHOLM",
        "link": "https://www.google.se/maps/place/Lerb%C3%A4cksgr%C3%A4nd+14,+124+66+Bandhagen/@59.2608025,18.0200287,17z/data=!3m1!4b1!4m5!3m4!1s0x465f774265229ea5:0x55cdb20134bf0720!8m2!3d59.2608025!4d18.0222174"
      },
      {
        "_id": {
            "$oid": "5c260ae4e7179a748798d8ba"
        },
        "id": 10,
        "custom_fields": "contact_info_email",
        "value": "info@autonaxis.se",
        "link": "info@autonaxis.se"
      }
    ];

    let res = {
      "menu": menu,
      "page_about_us": page_about_us,
      "page_contact": page_contact,
      "slider": slider,
      "blocks": blocks,
      "buttons": buttons,
      "media": media,
      "custom_fields": custom_fields
    };

    return dispatch(fetchPosts(res));

  };
};



// WEBPACK FOOTER //
// ./src/store/actions/index.js